export default __webpack_public_path__ + "static/media/steve_work_4.66bd8756.png";